<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i (click)="modalClose()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Loader -->
@if (loading) {
<div class="loading-container" style="text-align: center; padding: 50px;">
  <i style="color: #e12827; font-size: 36px;" class="fa fa-spinner fa-spin"></i>
</div>
}

<!-- Modal Footer -->
@if (!loading) {
<div class="modal-footer">
  <button class="delete-button" 
          type="button" 
          [disabled]="loading" 
          (click)="deletePayment()">
    @if (loading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Delete
  </button>
  <button class="cancel-button" 
          type="button" 
          (click)="modalClose()">Cancel</button>
</div>
}
